import {BaseContainerModel} from '../../base-container.model';
import {bl_wf_issue_hdr_RowClass} from '../../../dbschema/bl_wf_issue_hdr.model';
import {bl_wf_issue_ext_RowClass} from "../../../dbschema/bl_wf_issue_ext.model";
import {bl_wf_issue_event_RowClass, bl_wf_issue_line_RowClass} from "../../../dbschema";

export class InquiryContainerModel extends BaseContainerModel {
  bl_wf_issue_hdr: bl_wf_issue_hdr_RowClass = new bl_wf_issue_hdr_RowClass();
  bl_wf_issue_exts: bl_wf_issue_ext_RowClass[] = [];
}
